// extracted by mini-css-extract-plugin
module.exports = {"placeholderLoader":"Placeholder_placeholderLoader__b0lfi","mover":"Placeholder_mover__1cF2i","full":"Placeholder_full__Mq4Dq","dark":"Placeholder_dark__1IdeB"};